import Fazo from "../assets/fazo.png";
import hunter from "../assets/pricehunter.png";
import rentin from "../assets/rentinn.png";
import weather from "../assets/weahther.png";
import dashboard from "../assets/dashboard.png";
import goshops from "../assets/goshops.png";
import topskill from "../assets/topskill.png";
import sti from "../assets/sti.png";
import trexpress from "../assets/trexpress.png";
const data = [
  {
    id: "1",
    title: "Topskill online education platform",
    description: "I created this site  for Topskill",
    image: {
      src: topskill,
      placeholderSrc:
        "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzIDIiPjwvc3ZnPg==",
    },
    links: {
      site: "https://topskill.uz/",
    },
    technologies: [
      "#html",
      "#css",
      "#sass",
      "#bootstrap",
      "#antd design",
      "#javaScript",
      "#typeScript",
      "#next js",
    ],
  },
  {
    id: "2",
    title: "STI Transportation",
    description: "I prepared this site for an American logistics company",
    image: {
      src: sti,
      placeholderSrc:
        "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzIDIiPjwvc3ZnPg==",
    },
    links: {
      site: "https://stitransportation.com/",
    },
    technologies: [
      "#typescript",
      "#react",
      "#antdesign",
      "redux",
      "#mui",
      "#i18next",
    ],
  },
  {
    id: "3",
    title: "TrExpress",
    description: "OnlinShop which I build with Next Js",
    image: {
      src: trexpress,
      placeholderSrc:
        "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzIDIiPjwvc3ZnPg==",
    },
    links: {
      site: "https://trexpress.uz/",
    },
    technologies: [
      "#typescript",
      "#nextjs",
      "#antdesign",
      "redux",
      "#mui",
      "#i18next",
    ],
  },
  {
    id: "4",
    title: "Fazo Uz",
    description: "Marketplace which I build with Typescript",
    image: {
      src: Fazo,
      placeholderSrc:
        "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzIDIiPjwvc3ZnPg==",
    },
    links: {
      site: "https://fazo.uz/",
    },
    technologies: [
      "#typescript",
      "#react",
      "#antdesign",
      "redux",
      "#mui",
      "#i18next",
    ],
  },
  {
    id: "5",
    title: " Price Hunter",
    description: "Marketplace which I did for my first job",
    image: {
      src: hunter,
      placeholderSrc:
        "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzIDIiPjwvc3ZnPg==",
    },
    links: {
      site: "https://pricehunterdemosite.netlify.app/",
      repo: "https://github.com/FaraJM21/pricehunter",
    },
    technologies: [
      "#react",
      "#css-modules",
      "#antdesign",
      "redux-toolkit",
      "#mui",
    ],
  },
  {
    id: "6",
    title: "RentIn",
    description: "My second real project which will be on web soon",
    image: {
      src: rentin,
      placeholderSrc:
        "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzIDIiPjwvc3ZnPg==",
    },
    links: {
      site: "https://rufiweb.netlify.app/",
      repo: "https://github.com/FaraJM21/RufiWeb",
    },
    technologies: ["#react", "#scss", "#mui", "#swiperjs", "#antdesign"],
  },
  {
    id: "7",
    title: "Weather Forecast",
    description:
      "That is my Weather Forecast Project which i first used and learned tailwind. It shows daily 5 hours of the day and 5 days of the week",
    image: {
      src: weather,
      placeholderSrc:
        "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzIDIiPjwvc3ZnPg==",
    },
    links: {
      site: "https://weather-forecast-daily.netlify.app/",
      repo: "https://github.com/FaraJM21/weatherapp",
    },
    technologies: ["#react", "tailwind", "#css", "#openweathermapapi"],
  },
  {
    id: "8",
    title: "Quran Kareem",
    description: "Full edition of Quran Kareem all ayahs with surahs included",
    image: {
      src: "https://img.freepik.com/premium-vector/vector-illustration-of-ramadan-kareem-with-al-quran_44392-103.jpg",
      placeholderSrc:
        "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzIDIiPjwvc3ZnPg==",
    },
    links: {
      site: "https://qurankareemapp.netlify.app/",
    },
    technologies: ["#react", "#scss", "#axios", "#api"],
  },
  {
    id: "9",
    title: "Admin Dashboard",
    description:
      "Admin Dashboard Web with several charts build with Tailwind and Syncfusion UI",
    image: {
      src: dashboard,
      placeholderSrc:
        "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzIDIiPjwvc3ZnPg==",
    },
    links: {
      site: "https://admindashboardweb.netlify.app/",
      repo: "https://github.com/FaraJM21/admindashboard",
    },
    technologies: ["#react", "#tailwind", "#syncfusionui"],
  },
  {
    id: "10",
    title: "Go Shops Shopping",
    description: "Shopping Project built with NextJS",
    image: {
      src: goshops,
      placeholderSrc:
        "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzIDIiPjwvc3ZnPg==",
    },
    links: {
      site: "https://goshops.org/",
    },
    technologies: ["#nextjs", "#scss", "#mui", "#axios", "#antdesign"],
  },
];

export default data;
